var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"form-modal-create-activity","size":"xl","centered":"","hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":"","full":"","title":_vm.selectedItem?.action === 'create'
      ? 'Thêm mới hoạt động'
      : 'Cập nhật hoạt động'},on:{"hidden":_vm.resetModal,"close":_vm.resetModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('FormProgramCreateActivity',{attrs:{"setupData":_vm.setupData,"selectedItem":_vm.selectedItem},on:{"close-modal":_vm.resetModal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }